"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { EvidenceReview } from "./types";
import { highlightParts } from "@/app/thermage/_data/highlights";
import { TranslatedContent, useLanguage } from '@/shared/i18n/provider';
import { formatMessage, translate } from '@/shared/i18n/catalog';
interface Props {
  review: EvidenceReview;
  topic: string;
  treatmentSlug?: string;
  sectionTitles: string[];
  slot: string;
}

/** The aspect shown comes from the list filter; the card itself carries no controls. */
export function EvidenceReviewCard(t0) {
  const $ = _c(89);
  const {
    review,
    topic,
    sectionTitles,
    slot,
    treatmentSlug: t1
  } = t0;
  const treatmentSlug = t1 === undefined ? "thermage" : t1;
  const {
    locale,
    catalog
  } = useLanguage();
  const pendingTranslation = locale !== "ko" && review.contentLocale !== locale;
  let note;
  let t2;
  if ($[0] !== catalog || $[1] !== locale || $[2] !== review.note) {
    note = translate(review.note, catalog);
    t2 = locale !== "ko" && /[가-힣]/.test(note);
    $[0] = catalog;
    $[1] = locale;
    $[2] = review.note;
    $[3] = note;
    $[4] = t2;
  } else {
    note = $[3];
    t2 = $[4];
  }
  const originalNote = t2;
  let t3;
  if ($[5] !== review.memberships || $[6] !== slot) {
    t3 = review.memberships.find(item => item.slot === slot) ?? review.memberships[0];
    $[5] = review.memberships;
    $[6] = slot;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const member = t3;
  let t4;
  if ($[8] !== member.slot) {
    t4 = member.slot.slice(-2);
    $[8] = member.slot;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const number = Number(t4);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[10] !== locale || $[11] !== member.slot || $[12] !== pendingTranslation || $[13] !== review.contentLocale || $[14] !== review.date || $[15] !== review.highlights || $[16] !== review.key || $[17] !== review.maskedCount || $[18] !== review.reviewState || $[19] !== review.source || $[20] !== review.text || $[21] !== review.translationMethod) {
    const parts = highlightParts(review.text, review.highlights[member.slot] ?? []);
    T0 = TranslatedContent;
    t10 = `evidence-${review.key}`;
    t11 = "full-review";
    t12 = "mb-[16px] scroll-mt-[72px] rounded-[16px] border border-line-2 bg-surface-2 p-[18px] target:border-accent-mint-400 md:p-[24px]";
    let t16;
    if ($[34] !== review.source) {
      t16 = <h2 className="text-14 font-bold text-ink-2">{review.source}</h2>;
      $[34] = review.source;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    const t17 = review.date;
    let t18;
    if ($[36] !== review.date) {
      t18 = review.date.replaceAll("-", ".");
      $[36] = review.date;
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    let t19;
    if ($[38] !== review.date || $[39] !== t18) {
      t19 = <time className="text-11 text-ink-4" dateTime={t17}>{t18}</time>;
      $[38] = review.date;
      $[39] = t18;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    if ($[41] !== t16 || $[42] !== t19) {
      t13 = <header className="mb-[12px] flex flex-wrap items-center justify-between gap-[10px]">{t16}{t19}</header>;
      $[41] = t16;
      $[42] = t19;
      $[43] = t13;
    } else {
      t13 = $[43];
    }
    const t20 = review.maskedCount ? "\uAC1C\uC778\uC815\uBCF4 \uB9C8\uC2A4\uD0B9 \uC801\uC6A9" : review.reviewState === "candidate" ? "\uC790\uB3D9 \uB9C8\uC2A4\uD0B9 \uC810\uAC80" : "\uACF5\uAC1C \uC804 \uAC1C\uC778\uC815\uBCF4 \uD655\uC778";
    if ($[44] !== t20) {
      t14 = <p className="mb-[14px] text-11 text-accent-mint-400">후기 전문 · {t20}</p>;
      $[44] = t20;
      $[45] = t14;
    } else {
      t14 = $[45];
    }
    if ($[46] !== locale || $[47] !== pendingTranslation || $[48] !== review.translationMethod) {
      t15 = locale !== "ko" && <p className="mb-[12px] text-12 text-ink-3">{pendingTranslation ? "\uD55C\uAD6D\uC5B4 \uC6D0\uBB38 \xB7 \uC804\uBB38 \uBC88\uC5ED \uC900\uBE44 \uC911" : review.translationMethod === "machine" ? "\uC790\uB3D9 \uBC88\uC5ED \xB7 \uC758\uBBF8\uAC00 \uB2E4\uB974\uBA74 \uD55C\uAD6D\uC5B4 \uC6D0\uBB38\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694." : "\uBC88\uC5ED\uBB38 \xB7 \uC6D0\uBB38\uC758 \uAC1C\uC778 \uACBD\uD5D8\uC744 \uADF8\uB300\uB85C \uC62E\uACBC\uC2B5\uB2C8\uB2E4."}</p>;
      $[46] = locale;
      $[47] = pendingTranslation;
      $[48] = review.translationMethod;
      $[49] = t15;
    } else {
      t15 = $[49];
    }
    t5 = "no";
    t6 = review.contentLocale === "zh" ? "zh-Hans" : review.contentLocale ?? "ko";
    t7 = "whitespace-pre-wrap break-words text-[14px] leading-[1.9] text-ink-2";
    t8 = "review-fulltext";
    t9 = parts.map(_temp);
    $[10] = locale;
    $[11] = member.slot;
    $[12] = pendingTranslation;
    $[13] = review.contentLocale;
    $[14] = review.date;
    $[15] = review.highlights;
    $[16] = review.key;
    $[17] = review.maskedCount;
    $[18] = review.reviewState;
    $[19] = review.source;
    $[20] = review.text;
    $[21] = review.translationMethod;
    $[22] = T0;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    T0 = $[22];
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t13 = $[26];
    t14 = $[27];
    t15 = $[28];
    t5 = $[29];
    t6 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  let t16;
  if ($[50] !== t5 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
    t16 = <blockquote translate={t5} lang={t6} className={t7} data-testid={t8}>{t9}</blockquote>;
    $[50] = t5;
    $[51] = t6;
    $[52] = t7;
    $[53] = t8;
    $[54] = t9;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  let t17;
  if ($[56] !== review.originalText) {
    t17 = review.originalText && <details className="mt-[14px] text-12 leading-[1.8] text-ink-3"><summary className="cursor-pointer py-[8px] text-accent-mint-400">한국어 원문 보기</summary><p translate="no" lang="ko" className="whitespace-pre-wrap break-words">{review.originalText}</p></details>;
    $[56] = review.originalText;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] !== member.basis || $[59] !== note || $[60] !== originalNote) {
    t18 = note && <p className="mt-[18px] border-t border-line-2 pt-[12px] text-12 leading-[1.7] text-ink-3">읽을 때 참고 · {member.basis === "context" ? "\uC2E4\uC81C \uACB0\uACFC\uAC00 \uC544\uB2CC \uC870\uAC74\xB7\uC804\uC5B8 \uCC38\uACE0\uC608\uC694. " : ""}{originalNote && <span>한국어 검수 메모 — </span>}<span translate="no" lang={originalNote ? "ko" : undefined}>{note}</span></p>;
    $[58] = member.basis;
    $[59] = note;
    $[60] = originalNote;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  const t19 = String(number);
  let t20;
  if ($[62] !== t19) {
    t20 = t19.padStart(2, "0");
    $[62] = t19;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  const t21 = `/${treatmentSlug}/v1/${topic}#section-${t20}`;
  const t22 = String(number);
  let t23;
  if ($[64] !== t22) {
    t23 = t22.padStart(2, "0");
    $[64] = t22;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  const t24 = sectionTitles[number - 1];
  let t25;
  if ($[66] !== catalog || $[67] !== t24) {
    t25 = translate(t24, catalog);
    $[66] = catalog;
    $[67] = t24;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  const t26 = `${t23} ${t25}`;
  let t27;
  if ($[69] !== catalog || $[70] !== t26) {
    t27 = formatMessage("{section} \xB7 \uAE00\uC5D0\uC11C \uBCF4\uAE30 \u2197", {
      section: t26
    }, catalog);
    $[69] = catalog;
    $[70] = t26;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== t21 || $[73] !== t27) {
    t28 = <Link href={t21} className="mt-[10px] inline-flex min-h-[44px] items-center text-12 text-accent-mint-400 underline underline-offset-4">{t27}</Link>;
    $[72] = t21;
    $[73] = t27;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== t10 || $[76] !== t11 || $[77] !== t12 || $[78] !== t13 || $[79] !== t14 || $[80] !== t15 || $[81] !== t16 || $[82] !== t17 || $[83] !== t18 || $[84] !== t28) {
    t29 = <article id={t10} data-testid={t11} className={t12}>{t13}{t14}{t15}{t16}{t17}{t18}{t28}</article>;
    $[75] = t10;
    $[76] = t11;
    $[77] = t12;
    $[78] = t13;
    $[79] = t14;
    $[80] = t15;
    $[81] = t16;
    $[82] = t17;
    $[83] = t18;
    $[84] = t28;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  let t30;
  if ($[86] !== T0 || $[87] !== t29) {
    t30 = <T0>{t29}</T0>;
    $[86] = T0;
    $[87] = t29;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  return t30;
}
function _temp(part) {
  return part.highlighted ? <mark key={part.start} className="box-decoration-clone rounded-[3px] border-b border-[#67977e] bg-[#244539] px-[2px] py-[2px] text-[#d2f8e4]">{part.text}</mark> : <span key={part.start}>{part.text}</span>;
}